import styles from "./RoomMovement.module.css";

import IconAndName from "../../components/IconAndName/IconAndName";

import { FaUserPlus, FaUpload } from "react-icons/fa";
import { useState } from "react";

import { useDispatch } from "react-redux";
import { openModal } from "../../redux/slices/modalSlice";
import { IoAddCircleOutline } from "react-icons/io5";
import CopyRight from "../../components/CopyRight/CopyRight";
import AllScheduledMovements from "../../sections/AllScheduledMovements/AllScheduledMovements"
import ProgramLevelMovements from "../../sections/ProgramLevelMovements/ProgramLevelMovements";


const RoomMovement = () => {
  // default or make it dynamic later

  const handleStudentMovement = () => {
    dispatch(openModal("studentMovement"));
  };

  const handleProgramMovement = () => {
    dispatch(openModal("programLevelMovement"));
  };

  const dispatch = useDispatch();

  const [activeTab, setActiveTab] = useState("All Scheduled Movements");

  const tab = [
    {
      label: "All Scheduled Movements",
      content: <AllScheduledMovements />,
    },
    {
      label: "Program Level Movements",
      content: 
       
           <ProgramLevelMovements />,
       
      
    },
  ];

  return (
    <>
      <div className={styles.background}>
        <div className={styles.StudentSection}>
          <div className={styles.maincontainer}>
            <div className={styles.container}>
              {/* <TabSwitch tabs={tab} /> */}
              {tab.map((item, index) => {
                return (
                  <div
                    key={index}
                    className={`${styles.tabOptions} ${
                      activeTab === item.label && styles.ActivetabOption
                    }`}
                    onClick={() => setActiveTab(item.label)}
                  >
                    {item.label}
                  </div>
                );
              })}
            </div>
            {activeTab === "All Scheduled Movements" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Configure Student Movement"
                  bgColor="Primary_Color"
                  onClick={handleStudentMovement}
                />
              </div>
            )}
            {activeTab === "Program Level Movements" && (
              <div className={styles.buttonRow}>
                <IconAndName
                  icon={<IoAddCircleOutline />}
                  title="Configure Program Level Movement"
                  bgColor="Primary_Color"
                  onClick={handleProgramMovement}
                />
              </div>
            )}
          </div>
          {tab.map((item) =>
            activeTab === item.label ? <>{item.content}</> : null
          )}
        </div>
      </div>
      <div>{<CopyRight />}</div>
    </>
  );
};

export default RoomMovement;
